import * as types from '@/store/mutations'

const PLD_SIDEBAR_LOCAL = 'PLD_SIDEBAR_LOCAL'

export const state = {
  is_loading: false,
  is_saving: false,
  is_searching: false,
  is_error: false,
  is_tab_loading: true,
  is_sidebar_open: localStorage.getItem(PLD_SIDEBAR_LOCAL) === 'true',
}

export const getters = {
  // get loading
  is_loading(state) {
    return state.is_loading
  },

  // get searching
  is_searching(state) {
    if (state.is_loading) return false
    return state.is_searching
  },

  // get saving action
  is_saving(state) {
    if (state.is_loading) return false
    return state.is_saving
  },

  is_error(state) {
    return state.is_error
  },

  // get tab_loading action
  is_tab_loading(state) {
    if (state.is_loading) return false
    return state.is_tab_loading
  },

  // get sidebar position
  is_sidebar_open(state) {
    return state.is_sidebar_open
  },
}

export const mutations = {
  [types.SET_LOADING](state, payload) {
    // change loading
    state.is_loading = Boolean(payload).valueOf()
  },

  [types.SET_SEARCHING](state, payload) {
    // change searching
    state.is_searching = Boolean(payload).valueOf()
  },

  [types.SET_SIDEBAR](state, payload) {
    // change sidebar position
    state.is_sidebar_open = Boolean(payload).valueOf()
    localStorage.setItem(PLD_SIDEBAR_LOCAL, state.is_sidebar_open)
  },

  [types.SET_SAVING](state, payload) {
    state.is_saving = Boolean(payload).valueOf()
  },

  [types.SET_TAB_LOADING](state, payload) {
    // change sidebar position
    state.is_tab_loading = Boolean(payload).valueOf()
  },

  [types.SET_ERROR](state, payload) {
    // change sidebar position
    state.is_error = Boolean(payload).valueOf()
  },

  [types.RESET_APP](state) {
    state.is_loading = false
    state.is_saving = false
    state.is_searching = false
    state.is_tab_loading = false
  },
}
